import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import immutableToJS from 'utils/immutableToJS';

import {
  currentCaseAssetSelector,
  currentCaseServiceProviderSelector,
} from 'redux/cases/selectors';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    assetInfo: PropTypes.shape({
      location: PropTypes.shape({
        lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    }),
    serviceProviderInfo: PropTypes.shape({
      address: PropTypes.shape({
        location: PropTypes.shape({
          lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      }),
    }),
  };

  Container.defaultProps = {
    assetInfo: {},
    serviceProviderInfo: {},
  };

  function mapStateToProps(state) {
    return {
      assetInfo: currentCaseAssetSelector(state),
      serviceProviderInfo: currentCaseServiceProviderSelector(state),
    };
  }

  return connect(mapStateToProps)(
    immutableToJS(Container),
  );
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/LocationWidget/CaseLocationContainer.js